import busyness from '@/assets/images/status/busyness.png'
import locking from '@/assets/images/status/locking.png'
import off from '@/assets/images/status/off.png'
import online from '@/assets/images/status/online.png'
import ring from '@/assets/images/status/ring.png'
import on from '@/assets/images/status/on.png'
import { i18n } from '@/i18n/index.js'

/**
 * 电话工作台 状态
 */
const STATUS_LIST = [
  { value: 1, label: `空闲`, status: 'free', icon: online },
  { value: 2, label: `离线`, status: 'leave', icon: off },
  { value: 3, label: `置忙`, status: 'busy', icon: busyness },
  { value: 4, label: `振铃`, status: 'ring', icon: ring },
  { value: 5, label: `接线中`, status: 'doing', icon: on }
]

/**
 * 在线客服 状态
 */
const IM_STATUS_LIST = [
  {
    value: 1,
    label: '空闲',
    icon: online,
    langCode: 'crm.onlineCs.status.leisure'
  },
  {
    value: 4,
    label: '会话中',
    icon: on,
    langCode: 'crm.onlineCs.status.conversation'
  },
  {
    value: 2,
    label: `忙碌`,
    icon: busyness,
    langCode: 'crm.onlineCs.status.busy'
  },
  { value: 3, label: '离开', icon: off, langCode: 'crm.onlineCs.status.leave' }
]

export const getStatusList = isIm => {
  return isIm ? IM_STATUS_LIST : STATUS_LIST
}

// 保留，从菜单权限快速提取path
function getMenuPaths(menus, project = 'h5newcallcenter') {
  const paths = [] // 只在函数开始时定义一次路径数组

  menus.forEach(item => {
    // 检查当前菜单项的 href 属性是否包含项目名称
    if (item.href && item.href.includes(project)) {
      paths.push(item.href)
    }
    // 如果存在子菜单，则递归调用 getMenuPaths 并处理返回的路径
    if (item.child && item.child.length > 0) {
      // 将子菜单的路径与当前路径合并
      paths.push(...getMenuPaths(item.child, project))
    }
  })
  return paths // 返回收集到的路径数组
}

export const getNewWorkbenchWhitePath = path => {
  if (path && oldWorkbenchWhitePaths.includes(path)) {
    return path.replace('h5newcallcenter', 'qmove-customer-service-workbench')
  }
  return path
}

export const oldWorkbenchWhitePaths = [
  '/h5newcallcenter/#/tr_callin/',
  '/h5newcallcenter/#/callin/home',
  '/h5newcallcenter/#/callin/',
  '/h5newcallcenter/#/imHome',
  '/h5newcallcenter/#/im',
  '/h5newcallcenter/#/simulate',
  '/h5newcallcenter/#/personal/tempsave',
  '/h5newcallcenter/#/personal/casehistory',
  '/h5newcallcenter/#/personal/myrushrecord'
]

export const menus = [
  {
    id: 6542,
    permissionCode: '',
    resName: i18n.t('crm.onlineCs.customer.service'),
    href: null,
    icon: null,
    specialPerm: [],
    child: [
      {
        id: 6552,
        permissionCode: '',
        resName: i18n.t('crm.onlineCs.online.customer'),
        href: '',
        icon: null,
        specialPerm: [],
        child: [
          {
            id: 4814,
            permissionCode: 'CustomService-Onlineworkbench',
            resName: i18n.t('crm.onlineCs.online.workbench'),
            href: '/qmove-customer-service-workbench/#/im',
            icon: '',
            child: null
          }
        ]
      }
    ]
  }
]
